import React, { useCallback, useEffect, useState } from 'react';
import clsx from 'clsx';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { withRouter } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { makeRowColumn } from 'lib/commonLib';
import Checkbox from '@material-ui/core/Checkbox/Checkbox';

const useStyles = makeStyles((theme) => ({
  totalCell: {
    height: 42,
    boxSizing: 'border-box',
    backgroundColor: '#f6f6f9 !important',
    borderTop: theme.palette.box.border,
  },
  cell: {
    fontSize: 13,
    color: theme.palette.table.cell.black,
    backgroundColor: theme.palette.table.cell.default,
    borderBottom: theme.palette.box.border,

    // 테이블 th, td 커스텀 css
    '& td.mb-corpName-text': {
      color: theme.palette.table.cell.blue,
      width: 120,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    '& .center': {
      textAlign: 'center',
    },
    '& .black, &.mb-clickCnt': {
      color: theme.palette.table.cell.black,
    },
    '& .red, &.mb-kakaoTotAdvrtsAmt, &.mb-campMobTotAdvrtsAmt, &.mb-avgAdvrtsAmt, &.mb-orderAmt, &.mb-mobRoas, &.mb-totEprsCnt, &.mb-advrtsAmt, &.mb-usedPoint, &.mb-totalUsedPoint':
      {
        color: theme.palette.table.cell.red,
      },
    '& .blue, &.mb-userId, &.mb-parEprsCnt, &.mb-prdtTrgtOccRate, &.mb-clickRate, &.mb-articleParEprsCnt, &.mb-nonEprsKwrdCnt':
      {
        color: theme.palette.table.cell.blue,
      },
    '& .green, &.mb-adverCnt, &.mb-ecpm, &.mb-roas, &.mb-directRoas, &.mb-sessionRoas, &.mb-mobSessionRoas, &.mb-totClickRate, &.mb-convRate, &.mb-parCnt':
      {
        color: theme.palette.table.cell.green,
      },
    '&.mb-point, &.mb-avgOrderAmt': {
      color: theme.palette.table.cell.purple,
    },
    '& .gray': {
      color: theme.palette.table.cell.gray,
    },

    '&.mb-ageRange div': {
      width: 100,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    '&.mb-kpi div': {
      width: 100,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    '&.mb-grpStr div': {
      width: 120,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    '&.pointer': {
      cursor: 'pointer',
    },
    '&.mb-url': {
      width: 150,
    },
    '& p': {
      margin: 0,
    },
  },
  tableBodyRow: {
    height: '42px',
    '&:hover > td': {
      backgroundColor: theme.palette.table.cell.active,
      '&:first-child': {
        backgroundColor: theme.palette.table.cell.active,
      },
    },
    '& > td:first-child': {
      position: 'sticky',
      top: 0,
      left: 0,
      zIndex: theme.zIndex.table.sticky,
      backgroundColor: theme.palette.table.cell.default,
      borderRight: theme.palette.table.border.body,
      borderBottom: theme.palette.table.border.body,
    },
  },
  isChild: {
    '& > td': {
      backgroundColor: theme.palette.table.cell.child,
      '&:first-child': {
        backgroundColor: theme.palette.table.cell.child,
      },
    },
  },
  expandRow: {
    cursor: 'pointer',
    '&.open > td': {
      backgroundColor: theme.palette.table.cell.expend,
      '&:first-child': {
        backgroundColor: theme.palette.table.cell.expend,
      },
    },
  },
  nonePName: {
    backgroundColor: 'yellow',
  },
  default: {
    '& > td': {
      padding: '5px 15px',
    },
  },
}));

/**
 * 테이블 row 컴포넌트
 * @param {Object} props
 */
const MbTableRow = (props) => {
  const classes = useStyles();
  const {
    headCells,
    row,
    customized = {},
    isTotal,
    childColumnSet,
    pointer,
    handleClick,
    hasCheckbox,
    index,
    expandTable,
    wantRowData,
    hasModal,
    isSelected,
  } = props;
  const [getSelected, setSelected] = useState(false);
  /**
   *  Head 체크박스 컨트롤 변경시 body 체크박스 컨트롤
   */
  useEffect(() => {
    if (typeof isSelected !== 'undefined') {
      setSelected(isSelected);
    }
  }, [isSelected]);

  /**
   * 체크박스 변경시
   */
  const getCheckValue = (e) => {
    //setSelected(!getSelected);
    handleClick(e);
  };

  /**
   * row 한줄 만들기
   */
  const makeCell = useCallback(() => {
    const cell = [];
    for (let headCell of headCells.values()) {
      const {
        id: headId,
        align,
        format,
        type,
        className,
        isAddColumn = false,
        makeRowFunc,
      } = headCell;

      const isChild = row.isChild;
      let content = row[headId];
      let title = null;

      if (
        isChild !== true &&
        isAddColumn === false &&
        (typeof row[headId] === 'undefined' || headId === 'SEQ')
      ) {
        // header 에 있는 값만 body에 뿌려줌
        continue;
      }

      if (typeof makeRowFunc !== 'undefined') {
        // 화면에서 추가하는 column
        content = makeRowFunc(row);
      } else {
        if (typeof customized[headId] !== 'undefined') {
          if (customized[headId].merged === true) {
            // 테이블 내용 합쳐진 경우
            continue;
          } else {
            content = customized[headId].makeBody(row, headCells);
          }
        } else if (isChild && typeof childColumnSet[headId] !== 'undefined') {
          // 세부사항 tr 이면서
          content = childColumnSet[headId]();
        } else {
          content = makeRowColumn(content, type, format);
          title = content;
        }
      }
      let makeCellClass;
      if (isTotal) {
        makeCellClass = clsx(className, classes.cell, classes.totalCell);
      } else {
        makeCellClass = clsx({ pointer }, className, classes.cell);
      }

      cell.push(
        <TableCell
          style={
            customized[headId] !== undefined
              ? customized[headId].bodyStyle
              : null
          }
          title={title}
          className={makeCellClass}
          key={headId}
          align={align}
        >
          <div>{content}</div>
        </TableCell>
      );
    }
    return cell; // eslint-disable-next-line
  }, [headCells, row, customized, childColumnSet, isTotal, pointer]);

  if (
    row[Object.keys(row)[0]] === 'WEB' ||
    row[Object.keys(row)[0]] === 'MOBILE'
  ) {
    if (row.isOpen === false || typeof row.isOpen === 'undefined') {
      row.display = false;
    }
    row.isChild = true;
  }

  let pnameClassFlag;
  if (typeof customized !== 'undefined') {
    if (typeof customized['PNAME'] !== 'undefined') {
      if (typeof row.SPNAME !== 'undefined') {
        if (row.SPNAME === '') {
          pnameClassFlag = customized['PNAME'].checkFlag;
        }
      }
    }
  }

  return (
    <TableRow
      tabIndex={-1}
      key={index}
      data-key={index}
      onClick={(expandTable || wantRowData || hasModal) && handleClick}
      style={row.display === false ? { display: 'none' } : null}
      className={clsx({
        [classes.default]: true,
        [classes.nonePName]: pnameClassFlag,
        [classes.isChild]: row.isChild,
        [classes.expandRow]: (expandTable && !row.isChild) || hasModal,
        open: row.isOpen,
        rowSelect: wantRowData,
        tableRow: true,
      })}
      classes={{ root: classes.tableBodyRow }}
    >
      {!isTotal && hasCheckbox ? (
        <TableCell padding="checkbox">
          <Checkbox
            checked={getSelected}
            onChange={getCheckValue}
            color="primary"
            inputProps={{ 'data-key': index }}
            //value={row[hasCheckbox.value]}
            // name={hasCheckbox.value}
          />
        </TableCell>
      ) : null}

      {makeCell()}
    </TableRow>
  );
};

// const equalComparison = (prevProps, nextProps) => {
//   let result = false;
//   //console.log('prevProps', prevProps);
//   //console.log('nextProps', nextProps);
//
//   return result;
// };

export default React.memo(withRouter(MbTableRow));
